import React, { useContext } from 'react';
import { Edit } from 'react-feather';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from 'reactstrap';
import Select from 'react-select';
import { USER_MASTER, ValidationLabel, RoleAccess } from '../../constant';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import UserContext from '../../context/userContext';
import LoaderResoinse from '../../loader/loader';
import { maxLengthCheck } from '../../utils/helper';

const UserAddModel = (props) => {
  const { onSubmit, close, error, name, setName, email, setEmail, phone, setPhone, password, setPassword, confirmPassword, setconfirmPassword, roleId, setRoleId, togglesubmit, trustIds, setTrustIds, bankIds, setBankIds, trustList, bankList, getBankByTrusts } = props;
  
  const { modal } = useContext(UserContext);
  const { loaderShow } = useContext(OrganizationContext);

  const roles = [
    { id: RoleAccess.TEMPLE_ADMIN, name: 'Temple Admin' },
    { id: RoleAccess.CASHIER, name: 'Cashier' },
    { id: RoleAccess.ACCOUNTANT, name: 'Accountant' },
    { id: RoleAccess.EVENT_COORDINATOR, name: 'Event Coordinator' }
  ];

  return (
    <>
      <Modal size="lg" isOpen={modal} toggle={() => close()}>
        {loaderShow === true && <LoaderResoinse />}
        <ModalHeader toggle={() => close()}>
          {togglesubmit ? (
            <span>{USER_MASTER.ADD_USER_MASTER}</span>
          ) : (
            <span>
              {USER_MASTER.EDIT_USER_MASTER} <span> </span>{' '}
              <Edit style={{ width: '50px', height: '20px', color: '#7366ff' }} />
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <h5> {USER_MASTER.USER_MASTER_DETAILS}</h5>
                </CardHeader>
                <CardBody>
                  <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                    <Row>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && name.length <= 0 ? 'validation' : 'non-validation'}
                        >
                          {error && name.length <= 0
                            ? ValidationLabel.nameRequired
                            : ValidationLabel.name}
                        </Label>
                        <Input
                          className={`${error && name.length <= 0 ? 'inputValidation' : ''} "form-control`}
                          name="name"
                          type="text"
                          placeholder="Name"
                          id="validationCustom01"
                          onChange={(e) => setName(e.target.value)}
                          value={name}
                        />
                      </Col>
                      <Col md="6 mb-4">
                        <Label htmlFor="validationCustom03">{'Email'}</Label>
                        <Input
                          className="form-control"
                          name="email"
                          type="email"
                          id="validationCustome22"
                          placeholder="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6 mb-4">
                        <Label htmlFor="validationCustom01">{'Phone'}</Label>
                        <Input
                          className={'form-control'}
                          name="phone"
                          type="number"
                          id="validationCustome22"
                          placeholder="Phone Number"
                          onChange={(e) => setPhone(e.target.value)}
                          value={phone}
                          min={'0'}
                          maxLength={10}
                          onInput={maxLengthCheck}
                          onWheel={(e) => e.target.blur()}
                        />
                      </Col>
                      <Col md="6 mb-4">
                        <Label htmlFor="roleId">{'Role'}</Label>
                        <Input
                          type="select"
                          name="roleId"
                          id="roleId"
                          className="form-control"
                          value={roleId}
                          onChange={(e) => setRoleId(e.target.value)}
                        >
                          <option value="">Select Role</option>
                          {roles.map(role => (
                            <option key={role.id} value={role.id}>{role.name}</option>
                          ))}
                        </Input>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6 mb-4">
                        <Label htmlFor="trustIds">{'Assign Trusts'}</Label>
                        <Select
                          isMulti
                          name="trustIds"
                          options={trustList}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={trustList.filter(obj => trustIds.includes(obj.value))}
                          onChange={(e) => {
                            const selectedTrusts = e.map(x => x.value);
                            setTrustIds(selectedTrusts);
                            getBankByTrusts(selectedTrusts);
                            const updatedBankIds = bankIds.filter(bid => {
                              const bank = bankList.find(b => b.value === bid);
                              return bank && selectedTrusts.includes(bank.trustId);
                            });
                            setBankIds(updatedBankIds);
                          }}
                        />
                      </Col>
                      <Col md="6 mb-4">
                        <Label htmlFor="bankIds">{'Assign Banks'}</Label>
                        <Select
                          isMulti
                          name="bankIds"
                          options={bankList.filter(bank => trustIds.includes(bank.trustId))}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={bankList.filter(obj => bankIds.includes(obj.value))}
                          onChange={(e) => setBankIds(e.map(x => x.value))}
                        />
                      </Col>
                    </Row>
                    {togglesubmit && (
                      <Row>
                        <Col md="6" mb="4">
                          <Label
                            htmlFor="password"
                            className={
                              (error && password.length <= 0) || (error && password.length < 8)
                                ? 'validation'
                                : 'non-validation'
                            }
                          >
                            {error && password.length <= 0
                              ? ValidationLabel.passwordRequired
                              : error && password.length < 8
                              ? ValidationLabel.passwordMaxLength
                              : ValidationLabel.password}
                          </Label>
                          <Input
                            className={`${
                              (error && password.length <= 0) || (error && password.length < 8)
                                ? 'inputValidation'
                                : ''
                            } "form-control`}
                            name="password"
                            type="password"
                            id="password"
                            placeholder="Password "
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                          />
                        </Col>

                        <Col md="6" mb="4">
                          <Label
                            htmlFor="confirmPassword"
                            className={
                              (error && confirmPassword.length <= 0) || (error && confirmPassword !== password)
                                ? 'validation'
                                : 'non-validation'
                            }
                          >
                            {error && confirmPassword.length <= 0
                              ? ValidationLabel.confirmPasswordRequired
                              : error && confirmPassword !== password
                              ? ValidationLabel.notMatch
                              : ValidationLabel.confirmPassword}
                          </Label>
                          <Input
                            className={`${
                              (error && confirmPassword.length <= 0) || (error && confirmPassword !== password)
                                ? 'inputValidation'
                                : ''
                            } "form-control`}
                            name="confirmPassword"
                            type="password"
                            id="confirmPassword"
                            placeholder="Confirm Password"
                            onChange={(e) => setconfirmPassword(e.target.value)}
                            value={confirmPassword}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row style={{ paddingTop: '30px' }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        value="Submit"
                        disabled={loaderShow === true ? 'desabled' : ''}
                      >
                        {'Submit'}
                      </button>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default UserAddModel;
